import { render, staticRenderFns } from "./AdministratorManage.vue?vue&type=template&id=9d221c1e&scoped=true"
import script from "./AdministratorManage.vue?vue&type=script&lang=js"
export * from "./AdministratorManage.vue?vue&type=script&lang=js"
import style0 from "./AdministratorManage.vue?vue&type=style&index=0&id=9d221c1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d221c1e",
  null
  
)

export default component.exports